import { isGrafitEmail } from "@grafit/shared/domain/user/user";
import { alertDevs } from "@grafit/shared/observability/sentry-front";
import { isProd } from "@grafit/shared/utils/envs.front";

const KEY = "last-login-date";
export function storeLastLoginDate(userEmail: string): void {
  alertDevsOnLoginBeforeExpire(userEmail);
  try {
    window.localStorage.setItem(KEY, new Date().toISOString());
  } catch {
    //pass
  }
}

export function clearLoginDate() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    //pass
  }
}

function alertDevsOnLoginBeforeExpire(userEmail: string): void {
  const now = new Date();
  const fiveDaysInMs = 5 * 24 * 60 * 60 * 1000;
  const oneMinuteInMs = 60 * 1000;

  try {
    const item = window.localStorage.getItem(KEY);
    if (!item) {
      return;
    }
    const lastStoredLoginDate = new Date(item);
    const timeSinceLastLogin = now.getTime() - lastStoredLoginDate.getTime();

    // Ignore if called within a minute (likely same login flow called multiple times)
    if (timeSinceLastLogin <= oneMinuteInMs) {
      return;
    }
    if (isGrafitEmail(userEmail)) {
      return;
    }

    if (timeSinceLastLogin <= fiveDaysInMs && isProd()) {
      alertDevs({
        error: new Error("The last login date on this computer is only 5 days ago, that's unexpected"),
        context: {
          now,
          lastStoredLoginDate,
          userEmail,
        },
      });
    }
  } catch {
    //pass
  }
}
